import axios from 'axios';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { getError } from '../../utils';
import { Store } from '../../Store';
import LoadingBox from '../../components/LoadingBox';
import MessageBox from '../../components/MessageBox';
import { useTranslation } from 'react-i18next';
import { paths } from '../../routes/paths';

import './Predio.css';
const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loadingRifas: true };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        rifas: action.payload.rifas,
        loadingRifas: false,
        itemQuantity: action.payload.totalAmount,
      };
    case 'FETCH_FAIL':
      return { ...state, loadingRifas: false, error: action.payload };
    case 'DELETE_REQUEST':
      return { ...state, loadingDelete: true, successDelete: false };
    case 'DELETE_SUCCESS':
      return {
        ...state,
        loadingDelete: false,
        successDelete: true,
      };
    case 'DELETE_FAIL':
      return { ...state, loadingDelete: false, successDelete: false };
    case 'DELETE_RESET':
      return { ...state, loadingDelete: false, successDelete: false };
    default:
      return state;
  }
};

function VerPredio() {
  const { t } = useTranslation();
  const [{ error, rifas, successDelete, loadingRifas }, dispatch] = useReducer(reducer, {
    rifas: [],
    loadingRifas: true,
    error: '',
    itemQuantity: 0,
  });

  const { state } = useContext(Store);
  const { _userInfo } = state;
  const navigate = useNavigate();

  //pagination
  const [itemsPerPage] = useState(15); //maxPostsperPage

  const [porcentajes] = useState({});

  const fetchRifas = async skip => {
    try {
      dispatch({ type: 'FETCH_REQUEST' });
      const { data } = await axios.get(`/api/rifas/${skip}/${itemsPerPage}`);
      if (data.rifas) {
        await Promise.all(
          data.rifas.map(async element => {
            porcentajes[element._id] = await porcentajeTicketsVendidos(element);
          })
        );
      }
      dispatch({ type: 'FETCH_SUCCESS', payload: data });
    } catch (err) {
      dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
    }
  };

  useEffect(() => {
    if (successDelete) {
      dispatch({ type: 'DELETE_RESET' });
    } else {
      fetchRifas(0);
    }
  }, [successDelete]);

  async function porcentajeTicketsVendidos(rifa) {
    try {
      const response = await axios.get(`/api/tickets/porcentajeTicketsVendidos/${rifa._id}`);
      return response.data;
    } catch (err) {
      dispatch({ type: 'FETCH_TICKETS_FAIL', payload: getError(err) });
    }
  }

  async function toTickets(index) {
    const rifa = rifas[index];
    navigate(paths.buyTickets(rifa._id));
  }

  return (
    <>
      {loadingRifas ? <LoadingBox></LoadingBox> : null}
      {error ? (
        <MessageBox variant='danger'>{error}</MessageBox>
      ) : (
        <div>
          {rifas.map((element, index) => (
            <Container
              fluid
              onClick={() => toTickets(index)}
              key={`ticket-${element._id || index}`}
            >
              <div className='row'>
                <div
                  className='layer2 col-6'
                  style={{
                    backgroundImage: `url(${element.rifaImage ? element.rifaImage.fileLink : ''})`,
                  }}
                >
                  <h1>
                    {`${element.nombre}`}
                    <br />
                    {`${porcentajes[element._id].vendidos}% ${t('raffle.sold')}`}
                    <br />
                    <br /> {t('raffle.enterAndBuyNumber')}
                  </h1>
                </div>
              </div>
              {/* <div className="container_row">
                <div className="layer1">
                  
                    <img
                      src={
                        element.rifaImage ? element.rifaImage.fileLink : ""
                      }
                      style={{ maxWidth: "50%", maxHeight: "50%" }}
                    />
                <div className="layer2">
                  <h1>
                    {`${element.nombre}`}
                    <br />
                    {`${porcentajes[element._id].vendidos}% vendido`}
                    <br />
                    <br /> Ingresa aqui y compra tu numero
                  </h1>
                </div>
                  
                </div>
              </div> */}
            </Container>
          ))}
        </div>
      )}
    </>
  );
}

export default VerPredio;
